import moment from "moment";
import { Tooltip } from "primereact/tooltip";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { history } from "../router";
import LoadingDots from "./ui/LoadingDots/LoadingDots";

import { copyForm, deleteForm, revokeForm, welcome as welcomeAction, createStatusForm } from "../actions";

import { FORMS_URL } from "../router/urls";
import HistoryStatusModal from "./program/history";

class RequestList extends Component {
	modal = HistoryStatusModal;

	welcome = (process_id) => (event) => {
		event.stopPropagation();

		welcomeAction(
			{ request_id: process_id, project: "fasttrack_on_status" },
			{
				success: () => {
					window.location.pathname = "/planner/";
				},
				error: () => {
					window.location.pathname = "/planner/";
				},
			}
		);
	};

	goForm = (opts) => (event) => {
		event.stopPropagation();
		event.preventDefault();

		const { form_type, process_id } = opts;
		history.push(FORMS_URL({ form_type, process_id }));
	};

	onDelete = (form_type, process_id) => (event) => {
		event.stopPropagation();
		event.preventDefault();

		this.props.deleteForm(form_type, process_id);
	};

	// onCopy = (form_type, process_id) => (event) => {
	// 	event.stopPropagation();
	// 	event.preventDefault();
	//
	// 	this.props.copyForm(form_type, process_id);
	// };

	// onRevoke = (form_type, process_id) => (event) => {
	// 	event.stopPropagation();
	// 	event.preventDefault();
	//
	// 	this.props.revokeForm(form_type, process_id);
	// };

	onPropagation = (event) => {
		event.stopPropagation();
	};

	// TODO: ???
	getRowAct = (item) => item.stage_title;

	getRowOp = (item) => {
		if (item.process_completed) {
			return "Не требуется";
		}
		if (item.process_stage === 100) {
			return (
				<button onClick={this.goForm({ form_type: item.init_type, process_id: item.process_id })}>
					Заполнить заявку
				</button>
			);
		}
		if (item.process_stage === 200) {
			return (
				<>
					<button onClick={this.goForm({ form_type: item.init_type, process_id: item.process_id })}>
						Заполнить заявку
					</button>
					<button onClick={this.goForm({ form_type: item.form_type, process_id: item.process_id })}>
						Запрос документов
					</button>
				</>
			);
		}

		return null;
	};

	// eslint-disable-next-line class-methods-use-this
	getProcessStatus = (item) => {
		// if (item.process_status) {
		// 	return item.process_status;
		// }
		// if (item.process_completed) {
		// 	return "Завершено";
		// }
		switch (item.form_status) {
			case 0:
				return "Черновик";
			case 1:
				return "Утверждена";
			case 2:
				return "На утверждении";
			case 3:
				return "Отклонена";
			case 6:
				return "Отправлена";
			case 7:
				return "Получена";
			case 9:
				return "Согласована";
			case 10:
				return "На утверждении";
			case 11:
				return "Утверждена";
			case 12:
				return "Оплачена";
			case 14:
				return "Закрыта";
			case 21:
				return "Допущена к защите";
			case 22:
				return "Не допущена к защите";
			case 34:
				return "Не утверждена";
			case 44:
				return "Не согласована";
			default:
				return "Неизвестно";
		}
	};

	showHistory = (request) => (event) => {
		event.stopPropagation();
		event.preventDefault();

		this.modal.show(request);
	};

	// Дает возможность создать заявку на статус,
	// поэтому target_request_type здесь всегда равен 1
	onCreate(e, form_type, request_id) {
		e.stopPropagation();
		e.preventDefault();
		const { createStatusForm } = this.props;

		createStatusForm(form_type, request_id, {
			source: "fasttrack",
			request_id: request_id,
		});
	}

	flowData(flow) {
		if (typeof flow === "undefined") {
			return <div />;
		}
		return (
			<div>
				{flow.name} ({moment(flow.recruitment_date_end).format("DD.MM.YYYY")} -{" "}
				{moment(flow.protection_date_end).format("DD.MM.YYYY")})
			</div>
		);
	}

	render() {
		const { forms, mode, loaders, flows } = this.props;

		return (
			<LoadingDots
				show={
					["forms", "flows", "mm-process", "slave-mentors", "mentor-process", "companies"].some((el) => loaders[el]) ||
					!this.props.modeLoaded
				}
			>
				{forms.length > 0 && (
					<div className="table-responsive text-block">
						<table className="table table-bordered table-hover request-list">
							<thead>
								<tr>
									<td>ID</td>
									<td>Поток</td>
									<td>Рег.№</td>
									<td>Дата</td>
									<td>Дата рег.</td>
									<td>Стадия</td>
									{mode === "working" && (
										<>
											<td>
												Статус
												<Tooltip position="top" target="#status" style={{ minWidth: "160px", whiteSpace: "nowrap" }}>
													- Получение
													<br /> - Согласование
													<br /> - Утверждение
													<br /> - Оплата
													<br /> - Допуск&nbsp;до&nbsp;защиты
												</Tooltip>
												<span
													id="status"
													className="glyphicon glyphicon-question-sign"
													style={{ marginLeft: ".75rem" }}
												/>
											</td>
											{/* <td>Действие</td> */}
											<td>Операции</td>
										</>
									)}
								</tr>
							</thead>
							<tbody>
								{/* TODO:
                  По возможности продумать как убрать без боли мутацию массив
                  [...forms].sort((a,b) => a.process_id > b.process_id ? 1 : -1) или вынести в отдельную функцию
                */}
								{forms
									.sort((a, b) => (a.process_id > b.process_id ? 1 : -1))
									.map((item) => (
										<tr
											className="report-list-group"
											key={item.process_id}
											onClick={this.goForm({ form_type: item.form_type, process_id: item.process_id })}
										>
											<td className="label-num-cell">
												<span className="no-desktop">№&nbsp;</span>
												{item.process_id || ""}
											</td>
											<td>
												<span className="no-desktop">Поток:&nbsp;</span>
												{this.flowData(flows.find((el) => el.id === item.flow_id))}
											</td>
											<td>
												<span className="no-desktop">Рег.№&nbsp;</span> {item.registration_number || ""}
											</td>
											<td>
												<span className="no-desktop">Дата:&nbsp;</span> {moment(item.form_date).format("DD.MM.YYYY")}
											</td>
											<td>
												<span className="no-desktop">Дата рег.:&nbsp;</span>
												{item.registration_date ? moment(item.registration_date).format("DD.MM.YYYY") : ""}
											</td>
											<td>
												<span className="no-desktop">Стадия:&nbsp;</span> {this.getRowAct(item)}
											</td>
											{mode === "working" && (
												<>
													<td>
														<div className="btn-group-vertical" role="group">
															<label className="btn btn-primary">{this.getProcessStatus(item)}</label>
															<button
																type="button"
																className="btn btn-success"
																onClick={this.showHistory(item.process_id)}
															>
																История
															</button>
														</div>
													</td>
													{/* <td>{this.getRowOp(item)}</td> */}
													<td>
														{/* TODO: вынести кнопки в отдельный компонент если они используются в других компонентах в проекте*/}
														{/* <button
                            className="btn btn-primary btn-xs"
                            title="Клонировать"
                            onClick={this.onCopy(item.form_type, item.process_id)}
                        >
                            <span className="glyphicon glyphicon-duplicate" />
                        </button> */}
														&nbsp;
														{item?.invoice_file && item.form_status === 11 && (
															<a
																className="btn btn-primary btn-xs"
																download
																title="Счёт"
																href={item?.invoice_file}
																target="_blank"
																onClick={this.onPropagation}
																rel="noreferrer"
															>
																<span className="glyphicon glyphicon-download-alt"> Счет</span>
															</a>
														)}
														&nbsp;
														{item?.certificate_file && (
															<a
																className="btn btn-primary btn-xs"
																download
																title="Сертификат"
																href={item?.certificate_file}
																target="_blank"
																onClick={this.onPropagation}
																rel="noreferrer"
															>
																<span className="glyphicon glyphicon-download-alt"> Сертификат</span>
															</a>
														)}
														&nbsp;
														{item?.protocol_file && (
															<a
																className="btn btn-primary btn-xs"
																download
																title="Протокол"
																href={item?.protocol_file}
																target="_blank"
																onClick={this.onPropagation}
																rel="noreferrer"
															>
																<span className="glyphicon glyphicon-download-alt"> Протокол</span>
															</a>
														)}
														&nbsp;
														{item.form_status === 0 && (
															<button
																className="btn btn-danger btn-xs"
																title="Удалить"
																onClick={this.onDelete(item.form_type, item.process_id)}
															>
																<span className="glyphicon glyphicon-remove" />
															</button>
														)}
														&nbsp;
														{(item.form_status === 11 || item.form_status === 12 || item.form_status === 21) && (
															<a
																className="btn btn-primary btn-xs"
																onClick={this.welcome(item.process_id)}
																title="Запланировать встречу"
															>
																Запланировать встречу
															</a>
														)}
														&nbsp;
														{item.process_completed && (
															<button
																className="btn btn-primary btn-xs"
																onClick={(event) => this.onCreate(event, item.form_type, item.process_id)}
															>
																<span>Создать заявку на статус</span>
															</button>
														)}
														{/*
                        &nbsp;
                          {item.form_status != 0 && <button className="btn btn-primary btn-xs" onClick={this.onRevoke(item.form_type, item.process_id)} title="Отозвать">
                            <span className="glyphicon glyphicon-arrow-left" />
                          </button>}
                        */}
													</td>
												</>
											)}
										</tr>
									))}
							</tbody>
						</table>
						<HistoryStatusModal
							ref={(modal) => {
								this.modal = modal;
							}}
						/>
					</div>
				)}
				{forms.length === 0 && <div className="text-block text-block_empty">Не найдено ни одной заявки</div>}
			</LoadingDots>
		);
	}
}

RequestList.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	forms: PropTypes.array.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	flows: PropTypes.array,
	loaders: PropTypes.shape({}).isRequired,
};

RequestList.defaultProps = {
	flows: [],
};

const mapDispatchToProps = {
	copyForm,
	deleteForm,
	revokeForm,
	createStatusForm,
};

const mapStateToProps = (state) => ({
	mode: state.forms.mode,
	forms: state.forms.forms,
	loaders: state.forms.loaders,
	modeLoaded: state.forms.modeLoaded,
	flows: state.forms.flows,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
